import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { ClubTypeRoutingModule } from './club-type-routing.module';
import { ClubTypeListComponent } from './club-type-list/club-type-list.component';
import { ClubTypeCreateComponent } from './club-type-create/club-type-create.component';

@NgModule({
  declarations: [ClubTypeListComponent, ClubTypeCreateComponent],
  imports: [
    CommonModule,
    ClubTypeRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class ClubTypeModule { }
